<z-select
    id="{{ id() }}"
    [floatLabelVariant]="'on'"
    [options]="options()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [placeholder]="placeholder()"
    [disabled]="disabled ?? false"
    [class]="class"
    [label]="showLabel() == true ? label() : ''"
    [showClear]="showClear()"
    [filter]="filter()"
    [class]="class"
    [ngModel]="model"
    (ngModelChange)="modelChange($event)"
    [ngModelOptions]="{ standalone: true }"
/>
